import moment from "moment";
import { forwardObject } from "../../Context/AppActions"; 
import { AllPaths } from "../../components/HR/TimeClock/Util";
import GetRecordById from "./getRecordById";
import { openTaskModal, setOpenChatModal } from "../../Context/ReduxContext"; 
import AwsServerService from "./AwsServerService";

// General utility functions moved from App.js
export function invertColor(hex, bw) {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
  }
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

export const getJobId = (taskId, allJobs) => {
    let jobs = [...allJobs];
    let filterJob = jobs.filter((one) => one.zProjectsJobRefId == taskId);
    if (filterJob.length > 0) {
      return filterJob[0].jobId;
    } else {
      return "";
    }
  }; 

export const getText = (text, taskid) => {
    let type = ["email", "popup", "notification"];
    text = text.replaceAll(`#$taskid:${taskid}$#`, "");
    if(!text?.includes("changed the status from") && !text?.includes("changed priority")&& !text?.includes("changed Task Flow")){
      text = text.replaceAll(`<span>`, "");
      text = text.replaceAll(`</span>`, "");
    }
    type.forEach((one) => {
      text = text.replaceAll(`#$type:${one}$#`, "");
    });
    return text.trim();
  };
export function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
}
export const getDate1 = (date1) => {
    const targetTimeZone = localStorage.getItem("TIMEZONE"); // Timezone of the datetime value
    const DateTime = moment.tz(date1, targetTimeZone).format();
    date1 = new Date(DateTime);
    return (
      (date1.getMonth() + 1 < 10 ? "0" : "") +
      (date1.getMonth() + 1) +
      "/" +
      (date1.getDate() < 10 ? "0" : "") +
      date1.getDate() +
      "/" +
      date1.getFullYear()
    );
  }; 

  // export const canAccess = (accessContext, moduleName, permissionKey) =>{
  //   const module = accessContext?.modulePermissions?.find(
  //       (item) => item.module_name?.toLowerCase() === moduleName.toLowerCase()
  //     );
  //   let isAccess = module?.permissions?.[permissionKey] === true;
  //   return isAccess;
  // }
  export const canAccess = (accessContext, moduleName, permissionKey) => { 
    let module = accessContext?.modulePermissions?.find(
        (item) => item.module_name?.toLowerCase() === moduleName.toLowerCase()
      );
    if(module == undefined && moduleName == "Pipeline Template"){
      module = accessContext?.modulePermissions
      ?.filter(m => m.module_name === "Settings")
      ?.flatMap(item =>
        item.sub_modules?.filter(
          it => it.submodule_name === "Pipeline"
        ) || []
      )[0];
    }
    if(module == undefined && moduleName !== "Pipeline Template"){
      module = accessContext?.modulePermissions
      ?.flatMap(item =>
        item.sub_modules?.filter(
          it => it.submodule_name === moduleName
        ) || []
      )[0];
    }  
  if (!module || !module.permissions) return false;

  if (moduleName === "Tasks") {
    const taskPermissionValue = module.permissions[permissionKey];

    if (["View", "Edit", "Trash"].includes(permissionKey)) {
      return taskPermissionValue ?? "None";
    }
  }

  return module.permissions[permissionKey] === true;
};
const resolvePermission = (perm, item, currentUser, user) => {
    if (perm === "All") return "YES";
    if (perm === "None") return "NO";

    if (perm === "Owned") {
      return (
        item?.Assignee === currentUser?.zuid 
        || item?.Supervisor === currentUser?.zuid
      ) ? "YES" : "NO";
    }

    if (perm === "Added") {
      return item?.CREATEDBY === user?.email_id ? "YES" : "NO";
    }

    if (perm === "Both") {
      return (
        item?.Assignee === currentUser?.zuid ||
        item?.Supervisor === currentUser?.zuid ||
        item?.CREATEDBY === user?.email_id
      ) ? "YES" : "NO";
    }

    return "NO";
  };

  export const getTaskAccess = (taskData, accessContext, AllUsers, user) => {
    const normalizedTaskData = Array.isArray(taskData)
    ? taskData
    : taskData
    ? [taskData]
    : [];
    
    const currentUser = AllUsers.find(
      item => item.email === user.email_id
    );

    const taskPermission = accessContext?.modulePermissions?.find(item => item.module_name === "Tasks");

    const editPerm = taskPermission?.permissions["Edit"];
    const deletePerm = taskPermission?.permissions["Trash"];

    const updatedTaskData = normalizedTaskData?.map(item => ({
      ...item,
      canEdit: resolvePermission(editPerm, item, currentUser, user),
      canDelete: resolvePermission(deletePerm, item, currentUser, user)
    }));
    return updatedTaskData;
  };

 export const canView = (modulePermissions, moduleName) => {
    const vi= (modulePermissions || [])?.some(
      (item) => {
        if (moduleName == "Tasks"){
          return (
            item.module_name?.toLowerCase() === moduleName.toLowerCase() &&
            item.permissions?.View != "None"
          )
        } else {
          return(
        item.module_name?.toLowerCase() === moduleName.toLowerCase() &&
        item.permissions?.View == true
          )
        }
        }
    );
    return vi;
  };
  export const canFieldAccess = (accessContext, moduleName, subModuleName, fieldName) =>{ 
    const selectedModule = accessContext?.fieldPermissions?.find(item => item?.module_name == moduleName);
    if(subModuleName){
      const subModuleObj = selectedModule?.sub_modules?.find(sub => sub.sub_module_name == subModuleName)
      const field = subModuleObj?.fields?.find(
        (item) => item.field_name?.toLowerCase() === fieldName.toLowerCase()
      )
      console.log("fieldName:- ",fieldName," subModuleName:-",subModuleName," module:-",selectedModule)
      console.log("field:-",field)
      let permissions = field?.permissions;
      const key = Object?.keys(permissions)?.find(
        (key) => permissions[key] === true
      ) || null;
      return key;
    } else {
      const field = selectedModule?.fields?.find(
        (item) => item.field_name?.toLowerCase() === fieldName.toLowerCase()
      )
      let permissions = field?.permissions;
      const key = Object?.keys(permissions)?.find(
        (key) => permissions[key] === true
      ) || null;
      return key;
    } 
  }

 export const getTime1 = (Time) => {
    const targetTimeZone = localStorage.getItem("TIMEZONE"); // Timezone of the datetime value
    const DateTime = moment.tz(Time, targetTimeZone).format();
    Time = new Date(DateTime);
    var hours = Time.getHours();
    var minutes = Time.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };
export function GetFormattedDate(date) {
  let dateObj = new Date(date);
  let month = dateObj.getMonth() + 1;
  let day = dateObj.getDate();
  let year = dateObj.getFullYear();
  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;
  return day + "/" + month + "/" + year;
}

export function getDateMonthOnly(dateSplit) {
  dateSplit = GetFormattedDate(dateSplit);
  dateSplit = dateSplit.split("/");
  let monthShortNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  let Month = parseInt(dateSplit[1]);
  return monthShortNames[Month - 1] + " " + dateSplit[0] + ", " + dateSplit[2];
}

export function toIsoString(date) {
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num) {
      return (num < 10 ? "0" : "") + num;
    };
  return (
    date.getFullYear() +
    "" +
    pad(date.getMonth() + 1) +
    "" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    "" +
    pad(date.getMinutes()) +
    "" +
    pad(date.getSeconds()) +
    dif +
    pad(Math.floor(Math.abs(tzo) / 60)) +
    "" +
    pad(Math.abs(tzo) % 60)
  );
}

 function convertChatMessageId(id) {
  id = id.split("%");
  let firstId = id[0];
  let secondId = id[1];
  secondId = secondId.replace("20", "");
  id = firstId + secondId;
  return id;
}

export function showMinutesInHoursAndMins(totalMinutes) {
  var sec_num = parseInt(totalMinutes, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes;
}

export function spacebetweenAMPM(time) {
  if (time && time.endsWith("AM")) {
    return time.replace("AM", " AM");
  }
  if (time && time.endsWith("PM")) {
    return time.replace("PM", " PM");
  }
  return time;
}

export function getGroupVal(groupValue) {
  if (groupValue) {
    groupValue = groupValue.split("-");
    groupValue = groupValue[groupValue.length - 1];
    return groupValue;
  }
}
// Static arrays moved from App.js
export const customLinkFields = [
  {
    field: "bis_link",
    id: "101",
    isChecked: false,
    isDragOver: false,
    isSearch: true,
    name: "Bis Link",
    type: 'link',
  },
  {
    field: "zola_link",
    id: "102",
    isChecked: false,
    isDragOver: false,
    isSearch: true,
    name: "Zola Link",
    type: 'link',
  },
  {
    field: "taxmap_link",
    id: "103",
    isChecked: false,
    isDragOver: false,
    isSearch: true,
    name: "Tax Map Link",
    type: 'link',
  },
  {
    field: "acris_link",
    id: "104",
    isChecked: false,
    isDragOver: false,
    isSearch: true,
    name: "Acris Link",
    type: 'link',
  }
];

export const firstArr = [
  "Deal_Name",
  "Closing_Date",
  "Account_Name",
  "Project_Address",
  "Project_Status",
  "House_Number",
  "Street_Name",
  "City",
  "State",
  "Zip_Code",
  "Latitude",
  "Longitude",
  "Is_NYC_Project",
  "Borough",
  "Service_Requested_Name",
  "Block_Number",
  "Lot_Number",
  "Bin_Number",
  "Community_Board_Number",
  "Occupancy_Classification_Building_2014_2008_Code",
  "Occupancy_Classification_of_Building",
  "Construction_Classification_Code_2014_2008_Code",
  "Construction_Classification_Code",
  "Multiple_Dwelling_Classification",
  "Number_of_Dwelling_Units",
  "Building_Height",
  "Number_of_Stories",
  "Zoning_District",
  "Commercial_Overlay",
  "Specials_Districts",
  "Zoning_Map_Number",
  "Tidal_Wetlands",
  "Fresh_Water_Wetland",
  "Flood_Hazard",
  "Coastal_Erosion_Hazard",
  "Special_Fire_District",
  "Landmark_Area",
  "Environmental_Restriction",
  "Conjunction",
  "Conjunction_Application_Number",
  "Stop_Work_Order_Exists_on_Property",
  "Active_Work_Without_Permit_Violations",
  "Asbestos_Required",
  "ACP5_Completed",
  "Asbestos_Inspector_Certificate_Number",
  "ACP5_Control_Number",
  "Certificate_of_Occupancy_Available",
  "NB_Application_Number",
  "Owner_Type",
  "Property_Owner_s_Name",
  "Owner_s_First_Name",
  "Owner_s_Middle_Initial",
  "Owner_s_Last_Name",
  "Owner_Phone_Number",
  "Owner_s_Email_Address",
  "Owner_s_Mailing_Address_Diff_Than_Property_Address",
  "Owner_s_Mailing_Address",
  "Owner_s_Street_Name",
  "Owner_s_House_Number",
  "Owner_s_City",
  "Owner_s_State",
  "Owner_s_Zip_Code",
  "Non_Profit",
  "DHCR",
  "Other_Owner_Company_Name",
  "Other_Owner_Mailing_Address",
  "Other_Owner_Street_Name",
  "Other_Owner_House_Number",
  "Other_Owner_City",
  "Other_Owner_State",
  "Other_Owner_Zip_Code",
  "Other_Owner_Officer_First_Name",
  "Other_Owner_Officer_Middle_Initial",
  "Other_Owner_Officer_Last_Name",
  "Other_Owner_Officer_Title",
  "Other_Owner_Phone_Number",
  "Other_Owner_Email_Address",
  "Condo_Company_Name",
  "Condo_Mailing_Address",
  "Condo_Street_Name",
  "Condo_House_Number",
  "Condo_City",
  "Condo_State_Name",
  "Condo_Zip_Code",
  "Condo_Officer_First_Name",
  "Condo_Officer_Middle_Initial",
  "Condo_Officer_Last_Name",
  "Condo_Officer_Title",
  "Condo_Phone_Number",
  "Condo_Email_Address",
  "Applicant",
  "General_Contractor",
  "Electrician",
  "Number_of_Interconnection",
  "Total_System_Size",
  "Total_Modules",
  "PV_Interconnection",
  "Project_Cost",
  "Owner",
  "Created_By",
  "Created_Time",
  "Modified_By",
  "Modified_Time",
]; 

if (!String.prototype.toHHMMSS) {
  String.prototype.toHHMMSS = function () {
    var sec_num = parseInt(this, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;
    if (seconds < 10) seconds = "0" + seconds;
    return hours + ":" + minutes + ":" + seconds;
  };
}

const handleClickNotes = (e, replaceText, noteIdPrefix, history, openInNewTab) => {
    let id = e.target.id.replaceAll(replaceText, "");
    id = id.split("%");
    let firstId = id[0];
    let secondId = id[1];
    secondId = secondId.replace("20", "");
    id = firstId + secondId;
    let lastElementId = e.currentTarget.lastElementChild.id;
    lastElementId = lastElementId.replaceAll("Deal-", "");
    navigate({
      pathname: "/d/Deals/DetailView/" + lastElementId,
      search: `note=${id}`,
      state: { data: {}, action: "Update", module: "Deals" },
    }, openInNewTab, history);
    let startInterval = setInterval(() => {
      let highlightElement = document.getElementById(`${noteIdPrefix}${id}`);
      if (highlightElement) {
        let highlightBody = document.getElementById(`notes-body${id}`);
        if (replaceText !== "Note-") {
          highlightElement.click();
        }
        highlightBody.style.background = "#d7e7ed";
        highlightElement.scrollIntoView();
        clearInterval(startInterval);
      }
    }, 500);
  }; 

  const handleClickNotesReply = (e, replaceText, noteIdPrefix, history, openInNewTab) => {
    let repId = e.target.id.replaceAll(replaceText, "");
    repId = repId.split("-");
    let replyId = convertChatMessageId(repId[1]);
    let commentId = convertChatMessageId(repId[0]);

    let lastElementId = e.currentTarget.lastElementChild.id;
    lastElementId = lastElementId.replaceAll("Deal-", "");
    navigate({
      pathname: "/d/Deals/DetailView/" + lastElementId,
      search: `note=${replyId}`,
      state: { data: {}, action: "Update", module: "Deals" },
    }, openInNewTab, history);
    let startInterval = setInterval(() => {
      let highlightElement = document.getElementById(
        `${noteIdPrefix}${replyId}`
      );
      if (highlightElement) {
        let highlightCommentBody = document.getElementById(
          `UniqueComment${commentId}`
        );
        let highlightBody = document.getElementById(`notes-body${replyId}`);
        if (replaceText !== "Note-") {
          highlightElement.click();
        }
        highlightCommentBody.click();
        highlightBody.style.background = "#d7e7ed";
        highlightElement.scrollIntoView();
        clearInterval(startInterval);
      }
    }, 500);
  };
  
  const navigate = (pathObjOrString, openInNewTab, history) => {
      if (openInNewTab) {
        let pathname = "";
        let search = "";
        if (typeof pathObjOrString === "string") {
          pathname = pathObjOrString;
        } else {
          pathname = pathObjOrString.pathname || "";
          search = pathObjOrString.search || "";
        };
        const fullUrl = window.location.origin + "/app/#" + pathname + search;
        window.open(fullUrl, "_blank", "noopener,noreferrer");
      } else {
        history.push(pathObjOrString);
      }
    };

export const handleNotificationHyperlink = async (e, history, allUsers, allClients, 
  cacheDeals, allTask, dispatch, reduxDispatch, openInNewTab) => {debugger


    let a  = e.currentTarget.querySelector('.notifications-hyperlinks');
    let isReminder= e.currentTarget.querySelector('.Custome-Notifications-link')
    if(isReminder?.name){ 
      if(isReminder?.name.includes("Calendar")){
        dispatch(forwardObject({module:isReminder?.name?.split("-")[0],data:{messageId:isReminder?.name?.split("-")[1]},state:"view"}))
      }else{
        dispatch(forwardObject({module:isReminder?.name,data:"",state:"view"}))
      }
      navigate(AllPaths[isReminder?.name?.split("-")[0]], openInNewTab, history);
      return;
    }
    let commonId = a?.lastElementChild?.id; 
    if (e.target.id.startsWith("User")) {
      let id = e.target.id.replaceAll("User-", "");
      let all = [...allUsers];
      all = all.filter((one) => one.email == id);
      if (all.length > 0) {
        all = all[0];
        navigate({
          pathname: `/setting/users/${all.id}/Users`,
          state: { tab: "Users" },
        }, openInNewTab, history);
      } 
    }
    if (e.target.id.startsWith("Note")) {
      handleClickNotes(e, "Note-", "comment", history, openInNewTab);
    }
    if (e.target.id.startsWith("Reply")) {
      handleClickNotesReply(e, "Reply-", "UniqueReply", history, openInNewTab);
    }
    if (e.target.id.startsWith("Comment")) {
      handleClickNotes(e, "Comment-", "UniqueComment", history, openInNewTab);
    }
    if (e.target.id.startsWith("Accounts")) {
      let id = e.target.id.replaceAll("Accounts-", "");
      let filterClient = allClients.filter((one) => one.id == id);
      if (filterClient.length > 0) {
        filterClient = filterClient[0];
        navigate({
          pathname: "/c/Accounts/DetailView/" + filterClient.id,
          state: { data: filterClient, action: "Update", module: "Accounts" },
        }, openInNewTab, history);
      }
    }
    if (e.target.id.startsWith("Deal")) {
      let id = e.target.id.replaceAll("Deal-", "");
      let filterDeal = cacheDeals.filter((one) => one.id == id);
      if (filterDeal.length > 0) {
        filterDeal = filterDeal[0];
        navigate({
          pathname: "/d/Deals/DetailView/" + filterDeal.id,
          state: { data: filterDeal, action: "DetailView", module: "Deals" },
        }, openInNewTab, history);
      }
    }
     if (e.target.id.startsWith("TaskComment")) {
      let lastElementId = e.currentTarget.lastElementChild.id;
      lastElementId = lastElementId.replaceAll("Deal-", "");
        if(!lastElementId){
        const dealMatch = e.currentTarget.innerHTML.match(/Deal-(\d+)/);
        if (dealMatch && dealMatch[1]) {
          lastElementId = dealMatch[1];
        }
      }
      // GetRecordById("Deals", lastElementId)
      //   .then((data) => {
      //     data = { ...data[0] };
        // let data = cacheDeals.filter((one) => one.id == lastElementId);
        let taskMatch = e.currentTarget.innerHTML.match(/Task-T-([a-zA-Z0-9]+)/); 
        if (e.currentTarget.innerHTML.includes("SubTask-")) {
            let subTaskMatch = e.currentTarget.innerHTML.match(/SubTask-T-([a-zA-Z0-9]+)/);
            if(subTaskMatch){
              taskMatch = subTaskMatch[1] + "/" + subTaskMatch[2];
            }
          } else if(taskMatch){
            taskMatch = taskMatch[0].replace("Task-", "");
          } else{
              console.log("No Task ID found");
          }
          let commentId = e.target.id.replaceAll("TaskComment-", "");
          // commentId = commentId.split("-");
          // let id = e.target.id.replaceAll("Task-", "");
          localStorage.setItem("CommentId", commentId);
            navigate({
              pathname: "/project/Tasks/defaultView/" + taskMatch,
              state: { data: "", action: "Update", module: "TASK" },
            }, openInNewTab, history);
          // await AwsServerService.getTaskById(ids[0]).then(res=>{
          //       let k=res[0]?.taskInfo;
          //       if (k) {
          //         reduxDispatch(openTaskModal({
          //             taskData: k,
          //             dealObj: data[0],
          //             taskAction: "Edit"
          //           }));
                // }
                // if (tasks.length > 0) {
                //   reduxDispatch(openTaskModal({
                //     taskData: tasks[0],
                //     dealObj: data,
                //     taskAction: "Edit"
                //   }));
                  // let startInterval = setInterval(() => {
                  //   let highlightElement = document.getElementById(
                  //     `Comment${ids[1]}`
                  //   );
                  //   if (highlightElement) {
                  //     highlightElement.classList.add("highlight-color");
                  //     highlightElement.scrollIntoView();
                  //     clearInterval(startInterval);
                  //   }
                  // }, 500);
                // }
              // }).catch(err=>console.log(err))
          // let tasks = [...allTask];
          // tasks = tasks.filter((one1) => one1.id_string == ids[0]);
        // })
        // .catch((err) => {
        //   console.error(err);
        // });
    }else if (e.target.id.startsWith("Task") || e.target.id.startsWith("SubTask")) {
      let lastElementId = e.currentTarget.lastElementChild.id;
      lastElementId = lastElementId.replaceAll("Deal-", "");
      if(!lastElementId){
       const dealMatch = e.currentTarget.innerHTML.match(/Deal-(\d+)/);
       if (dealMatch && dealMatch[1]) {
         lastElementId = dealMatch[1];
       }
      }
      // let filterDeal = cacheDeals.filter((one) => one.id == lastElementId);
      // GetRecordById("Deals", lastElementId)
      //   .then((data) => {
      //     data = { ...data[0] };

          let taskId = e.target.id.replaceAll("Task-", "");
          let subId = e.target.id.replaceAll("SubTask-", "");
          // await AwsServerService.getTaskById(id).then(res=>{
            navigate({
              pathname: "/project/Tasks/defaultView/" + (e.target.id.startsWith("SubTask") ? subId : taskId),
              state: { data: "", action: "Update", module: "TASK" },
            }, openInNewTab, history);
                // let k=res[0]?.taskInfo;
                // if (k) {
                  // reduxDispatch(openTaskModal({
                  //     taskData: k,
                  //     dealObj: filterDeal[0],
                  //     taskAction: "Edit"
                  //   }));
                // }
              // }).catch(err=>console.log(err))
          // let tasks = [...allTask];
          // tasks = tasks.filter((one1) => one1.id_string == id);
        // })
        // .catch((err) => {
        //   console.error(err);
        // });
    }
    if (e.target.id.startsWith("Chat") || (commonId && commonId?.startsWith("Chat"))) { 
      reduxDispatch(setOpenChatModal(true));
      let lastElementId = e.currentTarget.lastElementChild.id || commonId;
      lastElementId = lastElementId.replaceAll("Chat-", "");
      lastElementId = lastElementId.split("-");
      let chatId = lastElementId[0];
      let messageId = lastElementId[1];
      messageId = messageId.split("%");
      let firstId = messageId[0];
      let secondId = messageId[1];
      secondId = secondId.replace("20", "");
      messageId = firstId + secondId;
      let startInterval = setInterval(() => {
        let userElem = document.getElementById(`Notification${chatId}`);
        let messageEleme = document.getElementById(`Highlight${messageId}`);
        if (userElem || messageEleme) {
          userElem.click();
          if (messageEleme) {
            messageEleme.style.background = "rgb(202 212 215)";
            messageEleme.scrollIntoView();
          }
          if (userElem && messageEleme) {
            clearInterval(startInterval);
          }
        }
      }, 500);
    }
  }; 

export const aggregateTimeArr = (result) => {
    result = [...result];
    result.forEach((obj) => {
      if (obj.toTime) {
        obj.totaltime = obj.toTime - obj.fromTime;
      }
    });
    for (let i = 0; i < result.length; i++) {
      for (let j = i + 1; j < result.length; j++) {
        if (
          result[i].workDate == result[j].workDate &&
          result[i].timerLog == result[j].timerLog
        ) {
          if (result[i].timers) {
            result[i].timers.push(result[j]);
          } else {
            result[i].timers = [result[j]];
          }
          result[i].totaltime = result[i].totaltime + result[j].totaltime;
          result.splice(j, 1);
          j--;
        }
      } 
      if (!result[i].timers) {
        result[i].timers = [result[i]];
      }
    }
    result = result.sort((a, b) => new Date(b.workDate) - new Date(a.workDate));
    return result;
  };
 export const convert24to12 = (date) => {
      // let Time =  new Date(date);
      // Time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      if (date == "N/A" || date == "") {
        return date;
      } else {
        try {
          var hours = date.getHours();
          var minutes = date.getMinutes();
          // if(seconds>=30){
          //   minutes=minutes+1;
          // }
          var ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12;
          hours = hours ? hours : 12; // the hour '0' should be '12'
          minutes = minutes < 10 ? "0" + minutes : minutes;
          var strTime = hours + ":" + minutes + " " + ampm;
          return strTime;
        } catch (ex) {}
      }
    };
  
export const first = [
    "Task Name",
    "Project manager",
    "Assignee",
    "Time Tracking",
    "Priority",
    "Time Estimate",
    "Task Flow",
    "Status",
    "Pipeline",
    "Description",
    "Sequence No.",
    "Start Date",
    "End Date",
    "Transitions",
    "Created On",
    "Completion Date",
    "Latest Activity",
    "Attachments",
    "Comments",
    "Latest Comments",
    "Milestone",
    "Status Date",
    "SLA"
  ];
